// @flow

import styles from './PlanRows.scss';

type Props = {
  ariaLabel: string,
  children: React.Node,
};

export function PlanRows({ ariaLabel, children }: Props): React.MixedElement {
  return (
    <div role="radiogroup" aria-labelledby={ariaLabel} className={styles.root}>
      {children}
    </div>
  );
}
